<template lang="html">
<div  class="box loading-box">
     <van-overlay z-index="10000" :show="show">
    </van-overlay>
    <div class="van-toast van-toast--middle">
      <van-loading size="24px"  vertical>
        <span class="default" style="color: rgb(201, 201, 201)"> 加载中...</span>
      </van-loading>
    </div>
</div>
</template>
<script >

// import Vue from 'vue'

// import {Loading, Overlay} from 'vant'

// Vue.use(Overlay).use(Loading)
export default {
    props: ['msg'],
    data () {
        return {
            show: true
        }
    }
}
</script>

<style lang="stylus" scoped>
.box
  position absolute
  z-index 10001
  top 0
  left 0
  width 100%
  height 100%
  .van-overlay
    opacity 0.3
  .loading
    position relative
    top 45%
    left 0
    z-index 10002
    width 300px
    height 300px
    background-color #fff
</style>
<style lang="stylus" >
.loading-box
  .van-toast
    width 120px
    min-height 120px
    // background-color rgba(255, 255, 255, 0.5)
    box-shadow 0 0 10px rgba(0, 0, 0, 0.3)
    z-index 10002
</style>
